import script from "./MobileBatchBranchEditDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileBatchBranchEditDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MobileBatchBranchEditDrawer.vue?vue&type=style&index=0&id=622202d1&scoped=true&lang=css"
import "./MobileBatchBranchEditDrawer.vue?vue&type=style&index=1&id=622202d1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622202d1"]])

export default __exports__